import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.8812 3.04725C13.9172 2.85225 13.7537 2.676 13.5617 2.7225C12.3834 2.93625 11.1594 3.3075 9.94516 3.837C4.48441 6.18675 1.17841 10.7932 2.56666 14.127C3.61666 16.626 7.00516 17.694 10.9404 17.0715L10.1282 20.9535C10.0907 21.1485 10.2557 21.3255 10.4477 21.279C11.6252 21.0652 12.8492 20.694 14.0634 20.1645C19.5242 17.8147 22.8212 13.2082 21.4329 9.86475C20.3927 7.3755 17.0042 6.3075 13.0682 6.93L13.8812 3.04725Z",
  fill: "#0064FF"
}, null, -1);
const _hoisted_2 = [
  _hoisted_1
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_2);
}
const icV2LogoTossColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2LogoTossColor as default
};
